<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Způsob vypořádání záboru</label>
    <div class="input">
      <gmt-select
        [data]="inputData"
        field="occupationSolutionType"
        [optionItems]="occupationSolutionTypeOptions"
        (changed)="updated()"
      ></gmt-select>
    </div>
  </div>
  <div class="column-100" *ngIf="inputData.occupationSolutionType">
    <label [class.required]="isCancelled()">{{ 'Důvod požadavku' }}</label>
    <textarea [(ngModel)]="inputData.finalSolutionReason" (ngModelChange)="updated()" rows="5"></textarea>
  </div>

  <div class="column-100" *ngIf="isOtherChange()">
    <div class="checklist">
      <div class="other-changes-container">
        <div class="checklist-item unborder"
             (click)="inputData.finalSolutionOtherChange.changeOccupationType = !inputData.finalSolutionOtherChange.changeOccupationType; updated()">
          <gmt-checkbox [gmtChecked]="inputData.finalSolutionOtherChange?.changeOccupationType"></gmt-checkbox>
          <span>Změna typu záboru</span>
          <span class="other-change-current-value">{{ inputData.zabtyptx }}</span>
        </div>
        <div class="other-change-input-row" *ngIf="inputData.finalSolutionOtherChange?.changeOccupationType">
          <label class="required">Nový typ záboru</label>
          <gmt-select
            [optionItems]="occupationTypeList"
            [data]="inputData.finalSolutionOtherChange"
            field="newOccupationType"
            (changed)="updated()"
            required="true"
          ></gmt-select>
        </div>
        <ng-container *ngIf="inputData.finalSolutionOtherChange?.changeOccupationType && permanentWithPurchase.includes(inputData.finalSolutionOtherChange?.newOccupationType?.number) && acquirerList.length > 0">
          <div class="other-change-input-row">
            <label class="required">Nový nabyvatel</label>
            <gmt-select
              [optionItems]="acquirerList"
              [data]="inputData.finalSolutionOtherChange"
              field="newNabyvatel"
              (changed)="updated()"
              required="true"
            ></gmt-select>
          </div>
        </ng-container>
        <div class="checklist-item unborder" (click)="inputData.finalSolutionOtherChange.changeConstructionObjects = !inputData.finalSolutionOtherChange.changeConstructionObjects; updated()">
          <gmt-checkbox [gmtChecked]="inputData.finalSolutionOtherChange?.changeConstructionObjects"></gmt-checkbox>
          <span>Změna objektové skladby záboru</span>
        </div>
        <div class="other-change-input-row" *ngIf="inputData.finalSolutionOtherChange?.changeConstructionObjects">
          <label class="required">Objektová skladba</label>
          <gmt-select
            resource="construction-objects"
            [data]="inputData.finalSolutionOtherChange"
            field="newConstructionObjects"
            [multiselect]="true"
            [itemPipe]="constructionObjectNamePipe"
            [filter]="{ filters: { validity: 'valid' } }"
            selectTitle="Stavební objekt"
            (changed)="updated()"
            required="true"
          ></gmt-select>
        </div>
      </div>
    </div>
  </div>
</fieldset>
